import { Section } from '@policygenius/dif-ts-types';

const schema: Section = {
  nodeType: 'SECTION',
  content: '',
  urn: 'urn:pg:interview:section:continue-online-marijuana',
  rules: { operation: '=', field: 'children.all.valid', value: true },
  presentationRules: {
    section_insured_risk_condition_marijuana_recreational_follow_up: {
      operation: '=',
      field: 'question_insured_risk_condition_marijuana_history_type_medicinal.value',

      value: false,
    },
    question_insured_risk_condition_marijuana_medicinal_prescription_reason: {
      operation: '=',
      field: 'question_insured_risk_condition_marijuana_history_type_medicinal.value',

      value: true,
    },
  },
  children: [
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      content: 'Is your marijuana usage medicinal?',
      dataPoint: {
        urn: 'urn:pg:data-point:insured-risk-condition-marijuana-history-type-medicinal',
        dataType: 'boolean',
      },
      urn: 'urn:pg:interview:question:insured-risk-condition-marijuana-history-type-medicinal',
      rules: {
        operation: '=',
        field: 'value.present',

        value: true,
      },
    },
    {
      nodeType: 'SECTION',
      content: '',
      urn: 'urn:pg:interview:section:insured-risk-condition-marijuana-recreational-follow-up',
      rules: { operation: '=', field: 'children.all.valid', value: true },
      presentationRules: {
        question_insured_risk_condition_marijuana_recreational_usage_form_other_details: {
          operation: 'HAS',
          field:
            'question_virtual_insured_risk_condition_marijuana_recreational_usage_method.value',
          value: 'urn:pg:data-point:insured-risk-condition-marijuana-recreational-usage-form-other',
        },
      },
      children: [
        {
          nodeType: 'QUESTION',
          questionType: 'MULTI_CHOICE',
          content: 'In what form do you primarily use marijuana?',
          dataPoint: {
            urn: 'urn:pg:data-point:virtual-insured-risk-condition-marijuana-recreational-usage-method',
            dataType: 'text_list',
          },
          urn: 'urn:pg:interview:question:virtual-insured-risk-condition-marijuana-recreational-usage-method',
          choices: [
            {
              displayText: 'Inhales (vaporizers)',
              value:
                'urn:pg:data-point:insured-risk-condition-marijuana-recreational-usage-form-inhales',
            },
            {
              displayText: 'Smoke (blunts/spliffs)',
              value:
                'urn:pg:data-point:insured-risk-condition-marijuana-recreational-usage-form-smoke',
            },
            {
              displayText: 'Oral (edibles, ingestible oils)',
              value:
                'urn:pg:data-point:insured-risk-condition-marijuana-recreational-usage-form-oral',
            },
            {
              displayText: 'Tinctures (alcohol-based cannabis extracts)',
              value:
                'urn:pg:data-point:insured-risk-condition-marijuana-recreational-usage-form-tinctures',
            },
            {
              displayText: 'Other',
              value:
                'urn:pg:data-point:insured-risk-condition-marijuana-recreational-usage-form-other',
            },
          ],
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          content: 'Please describe "Other"',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-condition-marijuana-recreational-usage-form-other-details',
            dataType: 'text',
          },
          urn: 'urn:pg:interview:question:insured-risk-condition-marijuana-recreational-usage-form-other-details',
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
      ],
    },
    {
      nodeType: 'QUESTION',
      questionType: 'TEXT',
      content: 'What is the reason for your prescription or diagnosis?',
      dataPoint: {
        urn: 'urn:pg:data-point:insured-risk-condition-marijuana-medicinal-prescription-reason',
        dataType: 'text',
        subtype: 'long_text',
      },
      urn: 'urn:pg:interview:question:insured-risk-condition-marijuana-medicinal-prescription-reason',
      rules: {
        operation: '=',
        field: 'value.present',
        value: true,
      },
    },
    {
      nodeType: 'QUESTION',
      questionType: 'NUMBER',
      content: 'On average, how many times per month do you use marijuana?',
      helpText: 'If your frequency is less than monthly, please enter 1',
      dataPoint: {
        urn: 'urn:pg:data-point:insured-risk-condition-marijuana-average-use-per-month',
        dataType: 'integer',
      },
      urn: 'urn:pg:interview:question:insured-risk-condition-marijuana-average-use-per-month',
      rules: {
        operation: '>=',
        field: 'value',
        value: 1,
      },
    },
    {
      nodeType: 'QUESTION',
      questionType: 'DATE',
      content: 'When did you last use marijuana?',
      dataPoint: {
        urn: 'urn:pg:data-point:insured-risk-condition-marijuana-date-last-used',
        dataType: 'date',
      },
      urn: 'urn:pg:interview:question:insured-risk-condition-marijuana-date-last-used',
      rules: {
        operation: '=',
        field: 'value.present',
        value: true,
      },
    },
    {
      nodeType: 'QUESTION',
      questionType: 'TEXT',
      content: 'Please provide any relevant details about your marijuana usage.',
      dataPoint: {
        urn: 'urn:pg:data-point:insured-risk-condition-marijuana-additional-details',
        dataType: 'text',
        subtype: 'long_text',
      },
      urn: 'urn:pg:interview:question:insured-risk-condition-marijuana-additional-details',
    },
  ],
};

export default schema;
